const COLORS = {
  pink: "from-[#F43F5E] to-[#B22B42]",
  yellow: "from-[#FFC446] to-[#FF6A07]",
};

const GradientText = ({ children, className = "", color = "pink" }) => {
  const gradientClass = COLORS[color] || COLORS.pink;

  return (
    <span
      className={`bg-gradient-to-r ${gradientClass} bg-clip-text inline gap-0 text-transparent font-bold ${className}`}
    >
      {children ||   " اسمارت " }
    </span>
  );
};

export default GradientText;
